import { useMemo, useState } from "react";
import { generateVolumeChartData, determineChartGranularity } from "../utils/chartUtils";
export const useNetworkErrorsFilters = (allInteractions, dateRange) => {
    const [excludeNoCoverage, setExcludeNoCoverage] = useState(false);
    const [excludeLooping, setExcludeLooping] = useState(false);
    const interactions = useMemo(() => {
        let filtered = allInteractions;
        if (excludeNoCoverage) {
            filtered = filtered.filter((interaction) => {
                if (!interaction.CallFlow)
                    return true;
                const callFlow = interaction.CallFlow.toLowerCase();
                return !callFlow.includes("no coverage");
            });
        }
        if (excludeLooping) {
            filtered = filtered.filter((interaction) => {
                if (!interaction.CallFlow)
                    return true;
                const callFlow = interaction.CallFlow.toLowerCase();
                return !callFlow.includes("looking up schedule default");
            });
        }
        return filtered;
    }, [allInteractions, excludeNoCoverage, excludeLooping]);
    const filterCounts = useMemo(() => {
        const noCoverageCount = interactions.filter((interaction) => {
            if (!interaction.CallFlow)
                return false;
            const callFlow = interaction.CallFlow.toLowerCase();
            return callFlow.includes("no coverage");
        }).length;
        const loopingCount = interactions.filter((interaction) => {
            if (!interaction.CallFlow)
                return false;
            const callFlow = interaction.CallFlow.toLowerCase();
            return callFlow.includes("looking up schedule default");
        }).length;
        return { noCoverageCount, loopingCount };
    }, [interactions]);
    const groupedInteractions = useMemo(() => {
        const sorted = [...interactions].sort((a, b) => new Date(b.InteractionStartDateUtc).getTime() - new Date(a.InteractionStartDateUtc).getTime());
        const grouped = sorted.reduce((acc, interaction) => {
            const accountName = interaction.ToFilterObjectAccountName || "Unknown Account";
            if (!acc[accountName]) {
                acc[accountName] = [];
            }
            acc[accountName].push(interaction);
            return acc;
        }, {});
        const sortedGroupKeys = Object.keys(grouped).sort();
        const sortedGrouped = {};
        sortedGroupKeys.forEach((key) => {
            sortedGrouped[key] = grouped[key];
        });
        return sortedGrouped;
    }, [interactions]);
    const sortedInteractions = useMemo(() => {
        return Object.values(groupedInteractions).flat();
    }, [groupedInteractions]);
    const startDate = new Date(dateRange.startDate);
    const endDate = new Date(dateRange.endDate);
    const chartGranularity = useMemo(() => {
        return determineChartGranularity(startDate, endDate);
    }, [startDate, endDate]);
    const volumeChartData = useMemo(() => {
        return generateVolumeChartData(interactions, chartGranularity, startDate, endDate);
    }, [interactions, chartGranularity, startDate, endDate]);
    return {
        interactions,
        groupedInteractions,
        sortedInteractions,
        excludeNoCoverage,
        excludeLooping,
        setExcludeNoCoverage,
        setExcludeLooping,
        filterCounts,
        chartGranularity,
        volumeChartData,
        startDate,
        endDate,
    };
};
//# sourceMappingURL=useNetworkErrorsFilters.js.map